var map = {
	"./animate.css": 978,
	"./css/adult-entertainment.css": 1175,
	"./css/blogs.css": 931,
	"./css/error-page.css": 1176,
	"./css/info.css": 1177,
	"./css/solutions-for.css": 932,
	"./elagent/fonts/ElegantIcons.eot": 1297,
	"./elagent/fonts/ElegantIcons.svg": 1298,
	"./elagent/fonts/ElegantIcons.ttf": 1299,
	"./elagent/fonts/ElegantIcons.woff": 1300,
	"./elagent/style.css": 977,
	"./font-awesome/css/all.css": 976,
	"./font-awesome/css/webfonts/fa-brands-400.eot": 1301,
	"./font-awesome/css/webfonts/fa-brands-400.svg": 1302,
	"./font-awesome/css/webfonts/fa-brands-400.ttf": 1303,
	"./font-awesome/css/webfonts/fa-brands-400.woff": 1304,
	"./font-awesome/css/webfonts/fa-brands-400.woff2": 1305,
	"./font-awesome/css/webfonts/fa-regular-400.eot": 1306,
	"./font-awesome/css/webfonts/fa-regular-400.svg": 1307,
	"./font-awesome/css/webfonts/fa-regular-400.ttf": 1308,
	"./font-awesome/css/webfonts/fa-regular-400.woff": 1309,
	"./font-awesome/css/webfonts/fa-regular-400.woff2": 1310,
	"./font-awesome/css/webfonts/fa-solid-900.eot": 1311,
	"./font-awesome/css/webfonts/fa-solid-900.svg": 1312,
	"./font-awesome/css/webfonts/fa-solid-900.ttf": 1313,
	"./font-awesome/css/webfonts/fa-solid-900.woff": 1314,
	"./font-awesome/css/webfonts/fa-solid-900.woff2": 1315,
	"./img/Img-01.jpg": 985,
	"./img/Img-02.jpg": 986,
	"./img/Img-03.jpg": 987,
	"./img/Img-05.jpg": 988,
	"./img/Img-07.jpg": 989,
	"./img/K.png": 319,
	"./img/accept-crypto/dot.png": 105,
	"./img/accept-crypto/metamask.png": 320,
	"./img/accept-crypto/work1.png": 321,
	"./img/accept-crypto/work2.png": 322,
	"./img/accept-crypto/work3.png": 323,
	"./img/accept-crypto/work4.png": 324,
	"./img/b.png": 325,
	"./img/background.png": 326,
	"./img/blog-grid/author_img.png": 327,
	"./img/blog-grid/blog_list1.jpg": 990,
	"./img/blog-grid/blog_list2.jpg": 991,
	"./img/blog-grid/blog_list3.jpg": 992,
	"./img/blog-grid/blog_list4.jpg": 993,
	"./img/blog-grid/blog_single.png": 328,
	"./img/blog-grid/comment1.png": 329,
	"./img/blog-grid/comment2.png": 330,
	"./img/blog-grid/post_1.jpg": 994,
	"./img/blog-grid/post_2.jpg": 995,
	"./img/blog-grid/post_3.jpg": 996,
	"./img/blog-grid/post_4.jpg": 997,
	"./img/blog-grid/post_img_1.png": 331,
	"./img/blog-grid/post_img_2.png": 332,
	"./img/blog-grid/post_img_3.png": 333,
	"./img/blogs/next_page_arrow.png": 55,
	"./img/blogs/no_image.png": 334,
	"./img/blogs/right_arrow.png": 106,
	"./img/blogs/search_icon.png": 107,
	"./img/blogs/up_down.png": 108,
	"./img/br_logo.png": 335,
	"./img/breadcrumb/Icon.png": 336,
	"./img/breadcrumb/banner_bg.png": 337,
	"./img/breadcrumb/service.png": 338,
	"./img/breadcrumb/service_details.png": 339,
	"./img/breadcrumb/service_details_one.png": 340,
	"./img/card-flip/coming_soon.png": 102,
	"./img/card-flip/coming_soon_invert.png": 101,
	"./img/card-flip/v3.png": 104,
	"./img/cart1.jpg": 998,
	"./img/cart2.jpg": 999,
	"./img/comingsoon/comingsoon_bg.png": 341,
	"./img/comingsoon/comingsoon_corner.svg": 1000,
	"./img/comingsoon/rocket-new.svg": 342,
	"./img/comingsoon/v3.0.svg": 1001,
	"./img/common/arrow_left.png": 41,
	"./img/common/arrow_right.png": 42,
	"./img/common/automate.png": 109,
	"./img/common/banner-backgroud.png": 110,
	"./img/common/banner-image.png": 111,
	"./img/common/chargebacks.png": 112,
	"./img/common/comingsoon.png": 113,
	"./img/common/complete_api.png": 114,
	"./img/common/every-swap.png": 115,
	"./img/common/floatingtelegram.png": 116,
	"./img/common/floatingtelegramlarge.png": 117,
	"./img/common/googlePlay-black.png": 118,
	"./img/common/googlePlay.png": 119,
	"./img/common/iPhone-black.png": 120,
	"./img/common/iPhone-white.png": 121,
	"./img/common/iPhone.png": 122,
	"./img/common/icon1.png": 123,
	"./img/common/icon2.png": 124,
	"./img/common/icon3.png": 125,
	"./img/common/icon4.png": 126,
	"./img/common/icon5.png": 127,
	"./img/common/icon6.png": 128,
	"./img/common/liquidity-pool.png": 129,
	"./img/common/liquidity_provider.png": 130,
	"./img/common/middleman.png": 131,
	"./img/common/mockup-update1.png": 132,
	"./img/common/mockup-update2.png": 133,
	"./img/common/mockup.png": 134,
	"./img/common/new_floating_tele.svg": 135,
	"./img/common/pma_token_bg.png": 136,
	"./img/common/reward_banner_bg.png": 137,
	"./img/common/reward_header_image.png": 138,
	"./img/common/security.png": 139,
	"./img/common/share.png": 140,
	"./img/common/star.png": 56,
	"./img/common/transaction.png": 141,
	"./img/common/volitality.png": 142,
	"./img/common/zeroTransaction.png": 143,
	"./img/common/zero_transaction.png": 144,
	"./img/contact/contact1.png": 145,
	"./img/contact/contact2.png": 146,
	"./img/contact/contact3.png": 147,
	"./img/erp-home/action_img.png": 343,
	"./img/erp-home/background.png": 344,
	"./img/erp-home/banner_shap.png": 345,
	"./img/erp-home/cloud-computing.png": 346,
	"./img/erp-home/cloud_01.png": 347,
	"./img/erp-home/cloud_02.png": 348,
	"./img/erp-home/cloud_03.png": 349,
	"./img/erp-home/cloud_04.png": 350,
	"./img/erp-home/cloud_05.png": 351,
	"./img/erp-home/cloud_06.png": 352,
	"./img/erp-home/crm_img1.jpg": 1002,
	"./img/erp-home/crm_img2.jpg": 1003,
	"./img/erp-home/crm_img3.jpg": 1004,
	"./img/erp-home/erp_dashboard.jpg": 1005,
	"./img/erp-home/erp_icon1.png": 353,
	"./img/erp-home/erp_icon2.png": 354,
	"./img/erp-home/erp_icon3.png": 355,
	"./img/erp-home/erp_icon4.png": 356,
	"./img/erp-home/erp_icon5.png": 357,
	"./img/erp-home/erp_icon6.png": 358,
	"./img/erp-home/growth.png": 359,
	"./img/erp-home/img/01.png": 360,
	"./img/erp-home/img/02.png": 361,
	"./img/erp-home/img/03.png": 362,
	"./img/erp-home/img/04.png": 363,
	"./img/erp-home/img/05.png": 364,
	"./img/erp-home/img/06.png": 365,
	"./img/erp-home/img/07.png": 366,
	"./img/erp-home/img/08.png": 367,
	"./img/erp-home/img/09.png": 368,
	"./img/erp-home/img/10.png": 369,
	"./img/erp-home/img/11.png": 370,
	"./img/erp-home/img/12.png": 371,
	"./img/erp-home/img/13.png": 372,
	"./img/erp-home/img/14.png": 373,
	"./img/erp-home/img/15.png": 374,
	"./img/erp-home/img/16.png": 375,
	"./img/erp-home/img/17.png": 376,
	"./img/erp-home/img/18.png": 377,
	"./img/erp-home/img/19.png": 378,
	"./img/erp-home/img/20.png": 379,
	"./img/erp-home/quote.png": 380,
	"./img/erp-home/rocket.png": 381,
	"./img/erp-home/settings1.png": 382,
	"./img/erp-home/shape.png": 383,
	"./img/erp-home/testimonial_img.jpg": 1006,
	"./img/erp-home/testimonial_img2.jpg": 1007,
	"./img/error/404-not-found.png": 148,
	"./img/error_bg.png": 384,
	"./img/executors/block_monitor.png": 149,
	"./img/executors/database.png": 150,
	"./img/executors/executors.png": 151,
	"./img/executors/partners_logos.png": 152,
	"./img/executors/partners_logos_mobile.png": 153,
	"./img/executors/pull_payment_top_bg.png": 154,
	"./img/executors/pull_payment_top_bg_mobile.png": 155,
	"./img/executors/software.png": 156,
	"./img/executors/speaker.png": 157,
	"./img/favicon.png": 385,
	"./img/footer/bg.png": 386,
	"./img/footer/blog.png": 88,
	"./img/footer/facebook.png": 86,
	"./img/footer/github.png": 90,
	"./img/footer/medium.png": 87,
	"./img/footer/reddit.png": 89,
	"./img/footer/telegram.png": 387,
	"./img/footer/twitter.png": 85,
	"./img/footerbanner/background2.png": 388,
	"./img/footerbanner/createBMBG.png": 389,
	"./img/footerbanner/createBMBG1.png": 390,
	"./img/footerbanner/createBMBG2.png": 391,
	"./img/footerbanner/footer_banner_dark_telegram_mobile.png": 392,
	"./img/footerbanner/icon_telegram.png": 158,
	"./img/footerbanner/telegram_banner.png": 393,
	"./img/footerbanner/telegram_banner_dark.png": 394,
	"./img/forex/background1.png": 395,
	"./img/forex/banner_forex_bg.png": 396,
	"./img/forex/benefit.png": 397,
	"./img/forex/benefit_bg.png": 398,
	"./img/forex/benefit_bg_mobile.png": 399,
	"./img/forex/carousel1-back.png": 400,
	"./img/forex/carousel1.png": 401,
	"./img/forex/carousel2.png": 402,
	"./img/forex/carousel3.png": 403,
	"./img/forex/forex.png": 159,
	"./img/forex/forexBanner.png": 404,
	"./img/forex/forexBanner2.png": 405,
	"./img/forex/forex_banner_mobile.png": 406,
	"./img/forex/forex_image.png": 160,
	"./img/gaming/background.png": 407,
	"./img/gaming/custom_api_Icon.png": 161,
	"./img/gaming/custom_api_bg.png": 408,
	"./img/gaming/game-usecase-g.png": 409,
	"./img/gaming/icon1.png": 410,
	"./img/gaming/icon2.png": 411,
	"./img/gaming/useCase1.png": 412,
	"./img/gaming/useCase2.png": 413,
	"./img/home-chat/Messages.jpg": 1008,
	"./img/home-chat/Messages.png": 414,
	"./img/home-chat/book.png": 415,
	"./img/home-chat/box.png": 416,
	"./img/home-chat/chat.png": 417,
	"./img/home-chat/chat_01.png": 418,
	"./img/home-chat/chat_02.png": 419,
	"./img/home-chat/chat_icon.png": 420,
	"./img/home-chat/cloud.png": 421,
	"./img/home-chat/dashboard.png": 422,
	"./img/home-chat/dot.png": 423,
	"./img/home-chat/get_started_bg.png": 424,
	"./img/home-chat/john.png": 425,
	"./img/home-chat/left_leaf.png": 426,
	"./img/home-chat/live_chat.png": 427,
	"./img/home-chat/mobile.png": 428,
	"./img/home-chat/panguin_img_one.png": 429,
	"./img/home-chat/panguin_img_three.png": 430,
	"./img/home-chat/panguin_img_two.png": 431,
	"./img/home-chat/pluse.png": 432,
	"./img/home-chat/richard.png": 433,
	"./img/home-chat/right_leaf.png": 434,
	"./img/home-chat/skyp_1.png": 435,
	"./img/home-chat/skyp_2.png": 436,
	"./img/home-chat/support_dashboard.jpg": 1009,
	"./img/home-chat/triangle.png": 437,
	"./img/home-chat/video_icon.png": 438,
	"./img/home-event/about.jpg": 1010,
	"./img/home-event/banner_bg.jpg": 1011,
	"./img/home-event/chat.png": 439,
	"./img/home-event/conference.jpg": 1012,
	"./img/home-event/digital.jpg": 1013,
	"./img/home-event/dot.png": 440,
	"./img/home-event/image_01.jpg": 1014,
	"./img/home-event/image_02.jpg": 1015,
	"./img/home-event/image_03.jpg": 1016,
	"./img/home-event/image_04.jpg": 1017,
	"./img/home-event/image_05.jpg": 1018,
	"./img/home-event/image_06.jpg": 1019,
	"./img/home-event/instragram1.jpg": 1020,
	"./img/home-event/instragram2.jpg": 1021,
	"./img/home-event/instragram3.jpg": 1022,
	"./img/home-event/instragram4.jpg": 1023,
	"./img/home-event/instragram5.jpg": 1024,
	"./img/home-event/instragram6.jpg": 1025,
	"./img/home-event/leader.png": 441,
	"./img/home-event/logo_09.jpg": 1026,
	"./img/home-event/logo_10.jpg": 1027,
	"./img/home-event/logo_11.jpg": 1028,
	"./img/home-event/logo_12.jpg": 1029,
	"./img/home-event/marker.png": 442,
	"./img/home-event/marketing.jpg": 1030,
	"./img/home-event/meetup.png": 443,
	"./img/home-event/price_shap.png": 444,
	"./img/home-event/promo.jpg": 1031,
	"./img/home-event/team1.jpg": 1032,
	"./img/home-event/team2.jpg": 1033,
	"./img/home-event/team3.jpg": 1034,
	"./img/home-event/timer.png": 445,
	"./img/home-security/about_img_1.jpg": 1035,
	"./img/home-security/about_img_2.jpg": 1036,
	"./img/home-security/apple_icon.png": 446,
	"./img/home-security/banner.png": 447,
	"./img/home-security/leaf_clients1.png": 448,
	"./img/home-security/leaf_clients2.png": 449,
	"./img/home-security/mackbook.png": 450,
	"./img/home-security/padlock.png": 451,
	"./img/home-security/real-estate.png": 452,
	"./img/home-security/rocket.png": 453,
	"./img/home-security/security_1.png": 454,
	"./img/home-security/security_2.png": 455,
	"./img/home-security/security_3.png": 456,
	"./img/home-security/security_4.png": 457,
	"./img/home-security/shap.png": 458,
	"./img/home-security/sheld_bg.png": 459,
	"./img/home-security/shield.png": 460,
	"./img/home-security/windows_icon.png": 461,
	"./img/home-software/analytices1.png": 462,
	"./img/home-software/analytices2.png": 463,
	"./img/home-software/analytices3.png": 464,
	"./img/home-software/analytices4.png": 465,
	"./img/home-software/analytices5.jpg": 1037,
	"./img/home-software/analytices6.jpg": 1038,
	"./img/home-software/analytices7.jpg": 1039,
	"./img/home-software/analytices8.jpg": 1040,
	"./img/home-software/case.png": 466,
	"./img/home-software/down_bg.png": 467,
	"./img/home-software/elements_five.png": 468,
	"./img/home-software/elements_four.png": 469,
	"./img/home-software/elements_one.png": 470,
	"./img/home-software/elements_six.png": 471,
	"./img/home-software/elements_three.png": 472,
	"./img/home-software/elements_two.png": 473,
	"./img/home-software/line_02.png": 474,
	"./img/home-software/logo_01.png": 475,
	"./img/home-software/logo_02.png": 476,
	"./img/home-software/logo_03.png": 477,
	"./img/home-software/logo_04.png": 478,
	"./img/home-software/logo_05.png": 479,
	"./img/home-software/logo_06.png": 480,
	"./img/home-software/logo_07.png": 481,
	"./img/home-software/logo_08.png": 482,
	"./img/home-software/logo_09.png": 483,
	"./img/home-software/logo_10.png": 484,
	"./img/home-software/logo_11.png": 485,
	"./img/home-software/logo_12.png": 486,
	"./img/home-software/mackbook.png": 487,
	"./img/home-software/pie.png": 488,
	"./img/home-software/setup_img1.png": 489,
	"./img/home-software/setup_img2.png": 490,
	"./img/home-software/setup_img3.png": 491,
	"./img/home-software/shap_3.png": 492,
	"./img/home-software/shap_one.png": 493,
	"./img/home-software/shap_two.png": 494,
	"./img/home-tracking/activity_icon.png": 495,
	"./img/home-tracking/aliexpress.png": 496,
	"./img/home-tracking/amazon.png": 497,
	"./img/home-tracking/analyze_icon.png": 498,
	"./img/home-tracking/apple.png": 499,
	"./img/home-tracking/computer_tracking_img.jpg": 1041,
	"./img/home-tracking/crismas.png": 500,
	"./img/home-tracking/cta.png": 501,
	"./img/home-tracking/cta_pattern_bg.jpg": 1042,
	"./img/home-tracking/google.png": 502,
	"./img/home-tracking/left-dot.png": 503,
	"./img/home-tracking/month.png": 504,
	"./img/home-tracking/right-dot.png": 505,
	"./img/home-tracking/tesla.png": 506,
	"./img/home-tracking/time_icon.png": 507,
	"./img/home-tracking/tracking_banner_img.png": 508,
	"./img/home-tracking/watch_1.png": 509,
	"./img/home-tracking/windows.png": 510,
	"./img/home/announcement_bg.png": 511,
	"./img/home/bussiness_leader_icon.png": 162,
	"./img/home/home-page-header-bg-mobile.png": 512,
	"./img/home/home-page-header-bg.png": 513,
	"./img/home/home_billing_section_bg.png": 514,
	"./img/home/home_billing_section_bg_mobile.png": 515,
	"./img/home/home_right_arrow.png": 163,
	"./img/home/home_trusted_logos.png": 164,
	"./img/home/liquidity_provider_icon.png": 165,
	"./img/home/liquidity_provider_layer.png": 166,
	"./img/home/liquidity_provider_layer_mobile.png": 167,
	"./img/home/liquidity_provider_right_bg.png": 168,
	"./img/home/liquidity_provider_right_image.png": 516,
	"./img/home/monthy_subs.png": 517,
	"./img/home/trusted_logo_bg.png": 169,
	"./img/home2/action_bg.png": 518,
	"./img/home2/file.png": 519,
	"./img/home2/inbox.png": 520,
	"./img/home2/report.png": 521,
	"./img/home2/undraw.png": 522,
	"./img/home3/action_image.png": 523,
	"./img/home3/dimond.png": 524,
	"./img/home3/logo_01.png": 525,
	"./img/home3/logo_02.png": 526,
	"./img/home3/logo_03.png": 527,
	"./img/home3/logo_04.png": 528,
	"./img/home3/logo_05.png": 529,
	"./img/home3/p_feature1.png": 530,
	"./img/home3/prototype_banner_img.png": 531,
	"./img/home3/prototype_banner_img2.png": 532,
	"./img/home3/psd.png": 533,
	"./img/home3/saas.png": 534,
	"./img/home3/tab.png": 535,
	"./img/home4/action_shap.png": 170,
	"./img/home4/author_img.png": 171,
	"./img/home4/banner_bg.png": 172,
	"./img/home4/banner_img.png": 173,
	"./img/home4/divider.png": 174,
	"./img/home4/dot.png": 175,
	"./img/home4/icon01.png": 176,
	"./img/home4/icon02.png": 177,
	"./img/home4/icon3.png": 178,
	"./img/home4/icon_04.png": 179,
	"./img/home4/icon_05.png": 180,
	"./img/home4/icon_shape1.png": 181,
	"./img/home4/icon_shape2.png": 182,
	"./img/home4/icon_shape3.png": 183,
	"./img/home4/icon_shape4.png": 184,
	"./img/home4/process_1.png": 185,
	"./img/home4/process_2.png": 186,
	"./img/home4/process_3.png": 187,
	"./img/home4/process_4.png": 188,
	"./img/home4/process_5.png": 189,
	"./img/home4/shape.png": 190,
	"./img/home4/team1.jpg": 536,
	"./img/home4/team2.jpg": 537,
	"./img/home4/work1.png": 191,
	"./img/home4/work2.png": 192,
	"./img/home4/work3.png": 193,
	"./img/home5/01.jpg": 1043,
	"./img/home5/02.jpg": 1044,
	"./img/home5/03.jpg": 1045,
	"./img/home5/banner_img.png": 538,
	"./img/home5/design1.png": 539,
	"./img/home5/design2.png": 540,
	"./img/home5/featured_bg_shape.png": 541,
	"./img/home5/featured_img1.png": 542,
	"./img/home5/icon1.png": 543,
	"./img/home5/icon2.png": 544,
	"./img/home5/icon3.png": 545,
	"./img/home5/icon_shape.png": 546,
	"./img/home5/php.jpg": 1046,
	"./img/home5/shap_tecture.png": 547,
	"./img/home6/dashboard.jpg": 1047,
	"./img/home6/featured_img_one.jpg": 1048,
	"./img/home6/featured_img_two.jpg": 1049,
	"./img/home6/feedback_img_one.png": 548,
	"./img/home6/feedback_img_three.png": 549,
	"./img/home6/feedback_img_two.png": 550,
	"./img/home6/logo_01.png": 551,
	"./img/home6/logo_02.png": 552,
	"./img/home6/logo_03.png": 553,
	"./img/home6/logo_04.png": 554,
	"./img/home6/logo_05.png": 555,
	"./img/home6/shape-1.png": 556,
	"./img/home6/shape2.png": 557,
	"./img/home6/trust_img.png": 558,
	"./img/home6/trust_img2.png": 559,
	"./img/home7/01.png": 560,
	"./img/home7/02.png": 561,
	"./img/home7/03.png": 562,
	"./img/home7/app.png": 563,
	"./img/home7/banner.png": 564,
	"./img/home7/google_icon.png": 565,
	"./img/home7/iPhoneX2.png": 566,
	"./img/home7/iPhonex.png": 567,
	"./img/home7/screenshot1.png": 568,
	"./img/home7/screenshot2.png": 569,
	"./img/home7/screenshot3.png": 570,
	"./img/home7/screenshot4.png": 571,
	"./img/home7/screenshot5.png": 572,
	"./img/home7/team_01.jpg": 1050,
	"./img/home7/team_02.jpg": 1051,
	"./img/home7/team_03.jpg": 1052,
	"./img/home7/team_04.jpg": 1053,
	"./img/home7/testimonial_author_img.png": 573,
	"./img/home7/text_one.png": 574,
	"./img/home7/text_three.png": 575,
	"./img/home7/text_two.png": 576,
	"./img/home8/banner_img.png": 577,
	"./img/home8/dot.png": 578,
	"./img/home8/fact.png": 579,
	"./img/home8/service_item_03.png": 580,
	"./img/home9/Fashiontv.png": 581,
	"./img/home9/ImLive.png": 582,
	"./img/home9/Shape_15.png": 583,
	"./img/home9/add_liquidity.png": 584,
	"./img/home9/banner_mac.png": 585,
	"./img/home9/bg_01.png": 586,
	"./img/home9/bg_02.png": 587,
	"./img/home9/billing.png": 194,
	"./img/home9/camster.png": 588,
	"./img/home9/coming_soon.svg": 1054,
	"./img/home9/decentralized.png": 195,
	"./img/home9/featured_img.png": 589,
	"./img/home9/featured_img_two.png": 590,
	"./img/home9/flag.png": 591,
	"./img/home9/footer.png": 592,
	"./img/home9/grooby.png": 593,
	"./img/home9/icon1.png": 594,
	"./img/home9/icon2.png": 595,
	"./img/home9/icon3.png": 596,
	"./img/home9/icon4.png": 597,
	"./img/home9/icon5.png": 598,
	"./img/home9/icon6.png": 599,
	"./img/home9/icon7.png": 600,
	"./img/home9/icon8.png": 601,
	"./img/home9/icon_decentralized.png": 196,
	"./img/home9/icon_shape.png": 57,
	"./img/home9/icon_shape_two.png": 602,
	"./img/home9/img_6.png": 603,
	"./img/home9/ironfx.png": 604,
	"./img/home9/livejasmin.png": 605,
	"./img/home9/logo1.png": 606,
	"./img/home9/logo2.png": 607,
	"./img/home9/logo3.png": 608,
	"./img/home9/logo4.png": 609,
	"./img/home9/logo5.png": 610,
	"./img/home9/logo6.png": 611,
	"./img/home9/logo7.png": 612,
	"./img/home9/logo8.png": 613,
	"./img/home9/mac.png": 614,
	"./img/home9/map.png": 615,
	"./img/home9/monthy_subs.png": 616,
	"./img/home9/monthy_subs_mobile.png": 617,
	"./img/home9/pornhub.png": 618,
	"./img/home9/recurring.png": 619,
	"./img/home9/section_bg.png": 620,
	"./img/home9/segpay.png": 621,
	"./img/home9/shape-footer.png": 622,
	"./img/home9/shape.png": 623,
	"./img/home9/shape_two.png": 624,
	"./img/home9/telegram.png": 197,
	"./img/home9/telegram_bg.png": 625,
	"./img/home9/telegram_mobile.png": 626,
	"./img/home9/testimonial_img.png": 627,
	"./img/home9/testimonial_img2.png": 628,
	"./img/home9/triangle_bottom.png": 629,
	"./img/home9/triangle_top.png": 630,
	"./img/home9/trust.png": 631,
	"./img/home9/v3.0.svg": 1055,
	"./img/hosting/action_img.png": 632,
	"./img/hosting/business1.png": 633,
	"./img/hosting/business2.png": 634,
	"./img/hosting/h_blog1.jpg": 1056,
	"./img/hosting/h_blog2.jpg": 1057,
	"./img/hosting/hosting-image.png": 635,
	"./img/hosting/hosting_action_bg.png": 636,
	"./img/hosting/icon1.png": 637,
	"./img/hosting/icon10.png": 638,
	"./img/hosting/icon2.png": 639,
	"./img/hosting/icon3.png": 640,
	"./img/hosting/icon4.png": 641,
	"./img/hosting/icon5.png": 642,
	"./img/hosting/icon6.png": 643,
	"./img/hosting/icon7.png": 644,
	"./img/hosting/icon8.png": 645,
	"./img/hosting/icon9.png": 646,
	"./img/hosting/line_01.png": 647,
	"./img/hosting/line_02.png": 648,
	"./img/hosting/line_03.png": 649,
	"./img/hosting/line_04.png": 650,
	"./img/hosting/line_05.png": 651,
	"./img/hosting/line_06.png": 652,
	"./img/hosting/line_07.png": 653,
	"./img/hosting/line_08.png": 654,
	"./img/hosting/map.png": 655,
	"./img/hosting/region_map.png": 656,
	"./img/info/banner_info_mobile.png": 657,
	"./img/info/header-bg.png": 658,
	"./img/info/info_bg_banner.png": 659,
	"./img/info/info_image_01.png": 660,
	"./img/info/info_image_02.png": 661,
	"./img/info/info_timeline.png": 198,
	"./img/info/isometric_banner_bg.png": 199,
	"./img/info/mobile/header-bg.png": 662,
	"./img/info/mobile/info_timeline.png": 200,
	"./img/japanese/accept-crypto/metamask.png": 663,
	"./img/japanese/accept-crypto/work1.png": 664,
	"./img/japanese/accept-crypto/work2.png": 665,
	"./img/japanese/accept-crypto/work3.png": 666,
	"./img/japanese/accept-crypto/work4.png": 667,
	"./img/japanese/card-flip/coming_soon.png": 103,
	"./img/japanese/common/automate.png": 668,
	"./img/japanese/forex/carousel1-back.png": 669,
	"./img/japanese/forex/carousel1.png": 670,
	"./img/japanese/forex/carousel2.png": 671,
	"./img/japanese/forex/carousel3.png": 672,
	"./img/japanese/home/home-page-header-bg-mobile.png": 673,
	"./img/japanese/home/home-page-header-bg.png": 674,
	"./img/japanese/home/liquidity_provider_right_image.png": 675,
	"./img/japanese/home/monthy_subs.png": 676,
	"./img/japanese/home9/monthy_subs_mobile.png": 677,
	"./img/japanese/info/info_timeline.png": 201,
	"./img/japanese/info/mobile/info_timeline.png": 202,
	"./img/japanese/liquidity-providers/item.png": 678,
	"./img/japanese/otherbilling/api.png": 679,
	"./img/japanese/otherbilling/pertime.png": 680,
	"./img/japanese/otherbilling/peruse.png": 681,
	"./img/japanese/otherbilling/single.png": 682,
	"./img/japanese/pumapay-app/mwallet1.png": 683,
	"./img/japanese/pumapay-app/mwallet2.png": 684,
	"./img/japanese/pumapay-app/mwallet3.png": 685,
	"./img/japanese/pumapay-app/mwallet4.png": 686,
	"./img/japanese/pumapay-app/mwallet5.png": 687,
	"./img/japanese/pumapay-bridge/bridge-screen.png": 688,
	"./img/japanese/reward_scheme/pma_token_card.png": 689,
	"./img/japanese/solutions-for/billing-model.png": 203,
	"./img/japanese/solutions-for/pumapay-business-console.png": 204,
	"./img/japanese/solutions-for/pumaypay_connect.png": 205,
	"./img/japanese/solutions-for/videozing.png": 206,
	"./img/japanese/solutions/1.png": 207,
	"./img/japanese/solutions/2.png": 208,
	"./img/japanese/solutions/3.png": 209,
	"./img/japanese/solutions/4.png": 210,
	"./img/japanese/solutions/5.png": 211,
	"./img/japanese/solutions/6.png": 212,
	"./img/japanese/subscription/1.png": 690,
	"./img/japanese/subscription/2.png": 691,
	"./img/japanese/subscription/3.png": 692,
	"./img/japanese/subscription/4.png": 693,
	"./img/japanese/subscription/5.png": 694,
	"./img/japanese/subscription/6.png": 695,
	"./img/japanese/subscription/Infographic_mobile.png": 696,
	"./img/japanese/subscription/billing.png": 697,
	"./img/japanese/subscription/frequency.png": 698,
	"./img/japanese/subscription/infographic.png": 699,
	"./img/japanese/subscription/nomination-back.png": 700,
	"./img/japanese/subscription/nomination.png": 701,
	"./img/japanese/subscription/settlement-back.png": 702,
	"./img/japanese/subscription/settlement.png": 703,
	"./img/japanese/subscription/trial.png": 704,
	"./img/japanese/top-up/step1.png": 705,
	"./img/japanese/top-up/step2.png": 706,
	"./img/language/en.png": 213,
	"./img/language/iconClose.svg": 1058,
	"./img/language/iconCloseWhite.svg": 1059,
	"./img/language/iconOpen.svg": 1060,
	"./img/language/iconOpenWhite.svg": 1061,
	"./img/language/ja.png": 214,
	"./img/layer_eng.png": 707,
	"./img/liquidity-providers/higher_earning_potential.png": 708,
	"./img/liquidity-providers/icon-hand.png": 709,
	"./img/liquidity-providers/icon-money.png": 710,
	"./img/liquidity-providers/illustrations.png": 711,
	"./img/liquidity-providers/iluustrations.png": 712,
	"./img/liquidity-providers/item.png": 713,
	"./img/liquidity-providers/pma_usability.png": 714,
	"./img/liquidity-providers/provide-liquidity.png": 715,
	"./img/liquidity-providers/provide-liquidity_mobile.png": 716,
	"./img/liquidity-providers/provide-liquidityold.png": 717,
	"./img/loader.gif": 718,
	"./img/login_img.png": 719,
	"./img/login_img2.png": 720,
	"./img/logo-3-2x.png": 721,
	"./img/logo-sticky-2x.png": 722,
	"./img/logo-sticky.png": 723,
	"./img/logo-sticky2.png": 724,
	"./img/logo-sticky3.png": 725,
	"./img/logo-sticky4.png": 726,
	"./img/logo.png": 727,
	"./img/logo2.png": 728,
	"./img/logo2x-2.png": 729,
	"./img/logo2x.png": 730,
	"./img/logo3.png": 731,
	"./img/logo4.png": 732,
	"./img/logo7.png": 733,
	"./img/logo8.png": 734,
	"./img/mega-menu-img/Prototyping_Tool.jpg": 1062,
	"./img/mega-menu-img/analytices.jpg": 1063,
	"./img/mega-menu-img/coming_img.jpg": 1064,
	"./img/mega-menu-img/erp.jpg": 1065,
	"./img/mega-menu-img/home-animation.jpg": 1066,
	"./img/mega-menu-img/home-chat.jpg": 1067,
	"./img/mega-menu-img/home-event.jpg": 1068,
	"./img/mega-menu-img/home-security.jpg": 1069,
	"./img/mega-menu-img/home-track.jpg": 1070,
	"./img/mega-menu-img/home1.jpg": 1071,
	"./img/mega-menu-img/home10.jpg": 1072,
	"./img/mega-menu-img/home11.jpg": 1073,
	"./img/mega-menu-img/home12.jpg": 1074,
	"./img/mega-menu-img/home13.jpg": 1075,
	"./img/mega-menu-img/home14.jpg": 1076,
	"./img/mega-menu-img/home15.jpg": 1077,
	"./img/mega-menu-img/home16.jpg": 1078,
	"./img/mega-menu-img/home17.jpg": 1079,
	"./img/mega-menu-img/home2.jpg": 1080,
	"./img/mega-menu-img/home3.jpg": 1081,
	"./img/mega-menu-img/home4.jpg": 1082,
	"./img/mega-menu-img/home5.jpg": 1083,
	"./img/mega-menu-img/home6.jpg": 1084,
	"./img/mega-menu-img/home7.jpg": 1085,
	"./img/mega-menu-img/home8.jpg": 1086,
	"./img/mega-menu-img/home9.jpg": 1087,
	"./img/mega-menu-img/hosting.jpg": 1088,
	"./img/mega-menu-img/icon/app-d.png": 735,
	"./img/mega-menu-img/icon/blup.png": 736,
	"./img/mega-menu-img/pos.jpg": 1089,
	"./img/mega-menu-img/saas2-slider.png": 737,
	"./img/mega-menu-img/support.jpg": 1090,
	"./img/new-home/back_bg.png": 738,
	"./img/new-home/banner.png": 739,
	"./img/new-home/briteverify.png": 740,
	"./img/new-home/campfire.png": 741,
	"./img/new-home/email.png": 742,
	"./img/new-home/kissmetrics.png": 743,
	"./img/new-home/metorik.png": 744,
	"./img/new-home/nicereply-1.png": 745,
	"./img/new-home/p-1.png": 746,
	"./img/new-home/p-2.png": 747,
	"./img/new-home/p-3.png": 748,
	"./img/new-home/tab.png": 749,
	"./img/new-home/tab_2.png": 750,
	"./img/new-home/tab_3.png": 751,
	"./img/new-home/ticket-support.png": 752,
	"./img/new-home/tree-left.png": 753,
	"./img/new-home/tree-right.png": 754,
	"./img/new-home/tree.png": 755,
	"./img/new-home/update.png": 756,
	"./img/new-home/webhooks.png": 757,
	"./img/new-home/wedsite.png": 758,
	"./img/new/01.png": 759,
	"./img/new/0111.png": 760,
	"./img/new/02.png": 761,
	"./img/new/0222.png": 762,
	"./img/new/03.png": 763,
	"./img/new/04.png": 764,
	"./img/new/05.png": 765,
	"./img/new/06.png": 766,
	"./img/new/app_screen.png": 767,
	"./img/new/blog/blog_grid_1.jpg": 1091,
	"./img/new/blog/blog_grid_2.jpg": 1092,
	"./img/new/blog/blog_grid_3.jpg": 1093,
	"./img/new/blog/blog_grid_4.jpg": 1094,
	"./img/new/blog/blog_grid_5.jpg": 1095,
	"./img/new/blog/blog_grid_6.jpg": 1096,
	"./img/new/blog/blog_grid_7.jpg": 1097,
	"./img/new/blog/blog_grid_8.jpg": 1098,
	"./img/new/case/case_01.jpg": 1099,
	"./img/new/case/case_02.jpg": 1100,
	"./img/new/case/case_03.jpg": 1101,
	"./img/new/case/case_04.jpg": 1102,
	"./img/new/case/case_05.jpg": 1103,
	"./img/new/case/case_06.jpg": 1104,
	"./img/new/case/case_07.jpg": 1105,
	"./img/new/case/case_08.jpg": 1106,
	"./img/new/case/case_09.jpg": 1107,
	"./img/new/case/case_10.jpg": 1108,
	"./img/new/case/case_11.jpg": 1109,
	"./img/new/case/case_12.jpg": 1110,
	"./img/new/case/case_details_01.jpg": 1111,
	"./img/new/case/case_details_02.jpg": 1112,
	"./img/new/case/case_details_03.jpg": 1113,
	"./img/new/case/parallax.png": 768,
	"./img/new/coming_soon_bg.png": 769,
	"./img/new/company.jpg": 1114,
	"./img/new/cup.png": 770,
	"./img/new/digital_img.png": 771,
	"./img/new/error.png": 772,
	"./img/new/features_01.png": 773,
	"./img/new/feedback_shap.png": 774,
	"./img/new/home-split/contact.png": 775,
	"./img/new/iPhoneX.png": 776,
	"./img/new/icon.png": 777,
	"./img/new/icon/icon1.png": 778,
	"./img/new/icon/icon2.png": 779,
	"./img/new/icon2.png": 780,
	"./img/new/icon3.png": 781,
	"./img/new/intregration_1.png": 782,
	"./img/new/intregration_2.png": 783,
	"./img/new/intregration_3.png": 784,
	"./img/new/intregration_4.png": 785,
	"./img/new/laptop.png": 786,
	"./img/new/laptop_two.png": 787,
	"./img/new/leaf.png": 788,
	"./img/new/line_01.png": 789,
	"./img/new/line_02.png": 790,
	"./img/new/line_03.png": 791,
	"./img/new/logo_01.png": 792,
	"./img/new/logo_02.png": 793,
	"./img/new/logo_03.png": 794,
	"./img/new/logo_04.png": 795,
	"./img/new/logo_05.png": 796,
	"./img/new/member_01.jpg": 1115,
	"./img/new/new_shape.png": 797,
	"./img/new/phone.png": 798,
	"./img/new/price_bg.png": 799,
	"./img/new/shape_bg.png": 800,
	"./img/new/solution_01.jpg": 1116,
	"./img/new/solution_02.jpg": 1117,
	"./img/new/startup_banner_bg.png": 801,
	"./img/new/startup_banner_img.png": 802,
	"./img/new/startup_shap.png": 803,
	"./img/new/tab_shape_bg.png": 804,
	"./img/new/testimonial_bg.png": 805,
	"./img/new/testimonial_bg_shap.png": 806,
	"./img/new/testimonial_bg_two.png": 807,
	"./img/new/video_bg.jpg": 1118,
	"./img/new/video_img_01.png": 808,
	"./img/new/video_img_02.jpg": 1119,
	"./img/new/web_image.jpg": 1120,
	"./img/new_logo.png": 809,
	"./img/otherbilling/api.png": 215,
	"./img/otherbilling/automate.png": 216,
	"./img/otherbilling/bg.png": 217,
	"./img/otherbilling/bg_01.png": 218,
	"./img/otherbilling/bg_02.png": 219,
	"./img/otherbilling/billing.png": 220,
	"./img/otherbilling/customize.png": 221,
	"./img/otherbilling/freedom.png": 222,
	"./img/otherbilling/payment_bg.png": 223,
	"./img/otherbilling/pertime.png": 224,
	"./img/otherbilling/peruse.png": 225,
	"./img/otherbilling/single.png": 226,
	"./img/paywithcrypto/automate.png": 810,
	"./img/paywithcrypto/banner_mobile.png": 811,
	"./img/paywithcrypto/bg_outlet.png": 812,
	"./img/paywithcrypto/ecosystem.png": 813,
	"./img/paywithcrypto/exchange.png": 814,
	"./img/paywithcrypto/icon-1.png": 815,
	"./img/paywithcrypto/icon-2.png": 816,
	"./img/paywithcrypto/icon-3.png": 817,
	"./img/paywithcrypto/liquidity-bg.png": 818,
	"./img/paywithcrypto/paywithcrypto.png": 227,
	"./img/paywithcrypto/paywithcrypto1.png": 819,
	"./img/paywithcrypto/paywithcryptoBG.png": 820,
	"./img/portfolio-details/pr_details1.jpg": 1121,
	"./img/portfolio-details/pr_details2.jpg": 1122,
	"./img/portfolio-details/pr_details3.jpg": 1123,
	"./img/portfolio-details/pr_details4.jpg": 1124,
	"./img/portfolio/2-columns/grid1.jpg": 1125,
	"./img/portfolio/2-columns/grid2.jpg": 1126,
	"./img/portfolio/2-columns/grid3.jpg": 1127,
	"./img/portfolio/2-columns/grid4.jpg": 1128,
	"./img/portfolio/2-columns/grid5.jpg": 1129,
	"./img/portfolio/2-columns/grid6.jpg": 1130,
	"./img/portfolio/2-columns/grid7.jpg": 1131,
	"./img/portfolio/2-columns/grid8.jpg": 1132,
	"./img/portfolio/3-columns/3_col_1.jpg": 1133,
	"./img/portfolio/3-columns/3_col_10.jpg": 1134,
	"./img/portfolio/3-columns/3_col_11.jpg": 1135,
	"./img/portfolio/3-columns/3_col_12.jpg": 1136,
	"./img/portfolio/3-columns/3_col_2.jpg": 1137,
	"./img/portfolio/3-columns/3_col_3.jpg": 1138,
	"./img/portfolio/3-columns/3_col_4.jpg": 1139,
	"./img/portfolio/3-columns/3_col_5.jpg": 1140,
	"./img/portfolio/3-columns/3_col_6.jpg": 1141,
	"./img/portfolio/3-columns/3_col_7.jpg": 1142,
	"./img/portfolio/3-columns/3_col_8.jpg": 1143,
	"./img/portfolio/3-columns/3_col_9.jpg": 1144,
	"./img/portfolio/full-width/full_1.jpg": 1145,
	"./img/portfolio/full-width/full_10.jpg": 1146,
	"./img/portfolio/full-width/full_11.jpg": 1147,
	"./img/portfolio/full-width/full_12.jpg": 1148,
	"./img/portfolio/full-width/full_2.jpg": 1149,
	"./img/portfolio/full-width/full_3.jpg": 1150,
	"./img/portfolio/full-width/full_4.jpg": 1151,
	"./img/portfolio/full-width/full_5.jpg": 1152,
	"./img/portfolio/full-width/full_6.jpg": 1153,
	"./img/portfolio/full-width/full_7.jpg": 1154,
	"./img/portfolio/full-width/full_8.jpg": 1155,
	"./img/portfolio/full-width/full_9.jpg": 1156,
	"./img/pos/High-end-all-in-one-dual-screen.png": 821,
	"./img/pos/b_dashboard.png": 822,
	"./img/pos/cash-register.png": 823,
	"./img/pos/chat.png": 824,
	"./img/pos/credit-card.png": 825,
	"./img/pos/delivery-truck.png": 826,
	"./img/pos/ezgif-1-997e5035cba4.png": 827,
	"./img/pos/fotter_shap.png": 828,
	"./img/pos/icon1.png": 829,
	"./img/pos/icon2.png": 830,
	"./img/pos/icon3.png": 831,
	"./img/pos/item1.png": 832,
	"./img/pos/item2.png": 833,
	"./img/pos/item3.png": 834,
	"./img/pos/laptop.png": 835,
	"./img/pos/leaf-left.png": 836,
	"./img/pos/leaf-right.png": 837,
	"./img/pos/mailbox.png": 838,
	"./img/pos/man.png": 839,
	"./img/pos/pattern_01.png": 840,
	"./img/pos/pattern_02.png": 841,
	"./img/pos/people.png": 842,
	"./img/pos/pos.png": 843,
	"./img/pos/pos_about_img.png": 844,
	"./img/pos/pos_blog_1.png": 845,
	"./img/pos/pos_blog_2.png": 846,
	"./img/pos/pos_blog_3.png": 847,
	"./img/pos/pos_slideshow1.jpg": 1157,
	"./img/pos/pos_slideshow2.jpg": 1158,
	"./img/pos/pos_slideshow3.jpg": 1159,
	"./img/pos/shape.png": 848,
	"./img/pos/shape_bg.png": 849,
	"./img/pos/statistics.png": 850,
	"./img/pos/tab_pattern.png": 851,
	"./img/pos/wave_two.png": 852,
	"./img/pos/women.png": 853,
	"./img/price/one.png": 854,
	"./img/price/three.png": 855,
	"./img/price/two.png": 856,
	"./img/process/ASAN-logo-icon.png": 857,
	"./img/process/Avast_Antivirus.png": 858,
	"./img/process/UTorrent_(logo).png": 859,
	"./img/process/btFMmsoh.png": 860,
	"./img/process/logo-slack.png": 861,
	"./img/process/png-logo-design.png": 862,
	"./img/pumapay-app/background-wallet.png": 228,
	"./img/pumapay-app/buy crypto.png": 229,
	"./img/pumapay-app/control.png": 230,
	"./img/pumapay-app/live.png": 231,
	"./img/pumapay-app/mwallet1.png": 232,
	"./img/pumapay-app/mwallet2.png": 233,
	"./img/pumapay-app/mwallet3.png": 234,
	"./img/pumapay-app/mwallet4.png": 235,
	"./img/pumapay-app/mwallet5.png": 236,
	"./img/pumapay-app/privecy.png": 237,
	"./img/pumapay-app/support.png": 238,
	"./img/pumapay-app/user-feed1.png": 239,
	"./img/pumapay-app/user-feed2.png": 240,
	"./img/pumapay-app/user-feed3.png": 241,
	"./img/pumapay-app/user-feed4.png": 242,
	"./img/pumapay-app/user-feed5.png": 243,
	"./img/pumapay-app/user-feed6.png": 244,
	"./img/pumapay-app/user-feed7.png": 245,
	"./img/pumapay-bridge/bg_01.png": 246,
	"./img/pumapay-bridge/block.png": 247,
	"./img/pumapay-bridge/bridge-flow-1.png": 58,
	"./img/pumapay-bridge/bridge-flow-2.png": 59,
	"./img/pumapay-bridge/bridge-screen.png": 248,
	"./img/pumapay-bridge/clock.png": 249,
	"./img/pumapay-bridge/ethereum.png": 250,
	"./img/pumapay-bridge/evm-compatible.png": 251,
	"./img/qoute.png": 863,
	"./img/reward_scheme/exclamation_icon.png": 252,
	"./img/reward_scheme/pma_token_card.png": 864,
	"./img/reward_scheme/timer.svg": 865,
	"./img/saas/map.png": 866,
	"./img/seo/bike.png": 867,
	"./img/seo/car.png": 868,
	"./img/seo/cloud.png": 869,
	"./img/seo/cloud_bg.png": 870,
	"./img/seo/features_img.png": 871,
	"./img/seo/features_img_two.png": 872,
	"./img/seo/footer_bg.png": 873,
	"./img/seo/icon1.png": 874,
	"./img/seo/icon2.png": 875,
	"./img/seo/icon3.png": 876,
	"./img/seo/icon4.png": 877,
	"./img/seo/icon5.png": 878,
	"./img/seo/image.png": 879,
	"./img/seo/logo_01.png": 880,
	"./img/seo/logo_02.png": 881,
	"./img/seo/logo_03.png": 882,
	"./img/seo/logo_04.png": 883,
	"./img/seo/logo_05.png": 884,
	"./img/seo/logo_06.png": 885,
	"./img/seo/logo_07.png": 886,
	"./img/seo/logo_08.png": 887,
	"./img/seo/logo_09.png": 888,
	"./img/seo/shap.png": 889,
	"./img/seo/studies_img_one.jpg": 1160,
	"./img/seo/studies_img_three.jpg": 1161,
	"./img/seo/studies_img_two.jpg": 1162,
	"./img/seo/triangle_one.png": 890,
	"./img/seo/triangle_three.png": 891,
	"./img/seo/triangle_two.png": 892,
	"./img/solutions-for/accept-crypto.png": 253,
	"./img/solutions-for/adult-api.png": 254,
	"./img/solutions-for/adult-dynamic.png": 255,
	"./img/solutions-for/adult-entertainment-header.png": 256,
	"./img/solutions-for/adult-entertainmentBG.png": 257,
	"./img/solutions-for/adult-subscription.png": 258,
	"./img/solutions-for/adultBannerImage.png": 60,
	"./img/solutions-for/benefits-bg-01.png": 61,
	"./img/solutions-for/benefits-bg-02.png": 62,
	"./img/solutions-for/billing-model.png": 63,
	"./img/solutions-for/icons/babes.png": 259,
	"./img/solutions-for/icons/brazzers.png": 260,
	"./img/solutions-for/icons/camster.png": 261,
	"./img/solutions-for/icons/grooby.png": 262,
	"./img/solutions-for/icons/imlive.png": 263,
	"./img/solutions-for/icons/mofos.png": 264,
	"./img/solutions-for/icons/pornhub.png": 265,
	"./img/solutions-for/icons/twistys.png": 266,
	"./img/solutions-for/mobile/adult-page-mobile.png": 267,
	"./img/solutions-for/mobile/header-bg.png": 268,
	"./img/solutions-for/mobile/pornhub-comment-mobile-bg.png": 64,
	"./img/solutions-for/mobile/pumapay-comment-bg.png": 269,
	"./img/solutions-for/mobile/recurring-billing-bg01.png": 270,
	"./img/solutions-for/mobile/recurring-billing-img01.png": 271,
	"./img/solutions-for/mobile/recurring-billing-img02.png": 272,
	"./img/solutions-for/mobile/recurring-billing-img03.png": 273,
	"./img/solutions-for/no-chargebacks.png": 274,
	"./img/solutions-for/no-moddleman.png": 275,
	"./img/solutions-for/no-volatility-risks.png": 276,
	"./img/solutions-for/pornhub-comment-bg.png": 65,
	"./img/solutions-for/pornhub-logo.png": 66,
	"./img/solutions-for/processing-transaction.png": 277,
	"./img/solutions-for/pumapay-business-console-logo.png": 67,
	"./img/solutions-for/pumapay-business-console.png": 68,
	"./img/solutions-for/pumapay-comment-bg.png": 278,
	"./img/solutions-for/pumaypay_connect.png": 69,
	"./img/solutions-for/recurring-billing-bg01.png": 70,
	"./img/solutions-for/recurring_billing_bg.png": 279,
	"./img/solutions-for/videozing.png": 71,
	"./img/solutions-for/zero-transaction-fees.png": 280,
	"./img/solutions/1.png": 281,
	"./img/solutions/2.png": 282,
	"./img/solutions/3.png": 283,
	"./img/solutions/4.png": 284,
	"./img/solutions/5.png": 285,
	"./img/solutions/5mins.png": 286,
	"./img/solutions/6.png": 287,
	"./img/solutions/Mockups.png": 893,
	"./img/solutions/chose_currency.png": 894,
	"./img/solutions/easy.png": 895,
	"./img/solutions/ecosystem/Babes.png": 91,
	"./img/solutions/ecosystem/Camster.png": 92,
	"./img/solutions/ecosystem/brazzers.png": 93,
	"./img/solutions/ecosystem/grooby.png": 94,
	"./img/solutions/ecosystem/imlive.png": 95,
	"./img/solutions/ecosystem/lottocity.png": 96,
	"./img/solutions/ecosystem/mojohost.png": 97,
	"./img/solutions/ecosystem/pornhub.png": 98,
	"./img/solutions/ecosystem/rent14.png": 99,
	"./img/solutions/ecosystem/twistys.png": 100,
	"./img/solutions/fast.png": 288,
	"./img/solutions/flexible.png": 289,
	"./img/solutions/flexibleicon.png": 290,
	"./img/solutions/full_api.png": 291,
	"./img/solutions/imidiate.png": 292,
	"./img/solutions/nochargeback.png": 293,
	"./img/solutions/nocommitment.png": 294,
	"./img/solutions/nomiddlemen.png": 295,
	"./img/solutions/norisk.png": 896,
	"./img/solutions/play_with_any_crypto.png": 897,
	"./img/solutions/quickprocessing.png": 898,
	"./img/solutions/riskfree.png": 296,
	"./img/solutions/safe.png": 899,
	"./img/solutions/shape_01.png": 900,
	"./img/solutions/shape_02.png": 901,
	"./img/solutions/shape_03.png": 902,
	"./img/solutions/shape_04.png": 903,
	"./img/solutions/simple.png": 297,
	"./img/subscription/1.png": 904,
	"./img/subscription/2.png": 905,
	"./img/subscription/3.png": 906,
	"./img/subscription/4.png": 907,
	"./img/subscription/5.png": 908,
	"./img/subscription/6.png": 909,
	"./img/subscription/Infographic_mobile.png": 910,
	"./img/subscription/bg_mobile.png": 911,
	"./img/subscription/billing.png": 912,
	"./img/subscription/billing_bg.png": 913,
	"./img/subscription/frequency.png": 914,
	"./img/subscription/infographic.png": 915,
	"./img/subscription/nomination-back.png": 916,
	"./img/subscription/nomination.png": 917,
	"./img/subscription/settlement-back.png": 918,
	"./img/subscription/settlement.png": 919,
	"./img/subscription/trial.png": 920,
	"./img/svg.svg": 1163,
	"./img/teams/team_01.jpg": 1164,
	"./img/teams/team_02.jpg": 1165,
	"./img/teams/team_03.jpg": 1166,
	"./img/teams/team_04.jpg": 1167,
	"./img/teams/team_10.jpg": 1168,
	"./img/teams/team_12.jpg": 1169,
	"./img/teams/team_5.jpg": 1170,
	"./img/teams/team_6.jpg": 1171,
	"./img/teams/team_7.jpg": 1172,
	"./img/teams/team_8.jpg": 1173,
	"./img/teams/team_9.jpg": 1174,
	"./img/top-up/icon-1.png": 921,
	"./img/top-up/icon-2.png": 922,
	"./img/top-up/icon-3.png": 923,
	"./img/top-up/image_1.png": 924,
	"./img/top-up/image_2.png": 925,
	"./img/top-up/image_3.png": 926,
	"./img/top-up/step1.png": 927,
	"./img/top-up/step2.png": 928,
	"./img/white.png": 929,
	"./img/whiteAlt.png": 930,
	"./main.css": 979,
	"./responsive.css": 980,
	"./simple-line-icon/fonts/Simple-Line-Icons.dev.svg": 1316,
	"./simple-line-icon/fonts/Simple-Line-Icons.eot": 1317,
	"./simple-line-icon/fonts/Simple-Line-Icons.svg": 1318,
	"./simple-line-icon/fonts/Simple-Line-Icons.ttf": 1319,
	"./simple-line-icon/fonts/Simple-Line-Icons.woff": 1320,
	"./simple-line-icon/simple-line-icons.css": 975,
	"./themify-icon/fonts/themify.eot": 1321,
	"./themify-icon/fonts/themify.svg": 1322,
	"./themify-icon/fonts/themify.ttf": 1323,
	"./themify-icon/fonts/themify.woff": 1324,
	"./themify-icon/themify-icons.css": 974
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1296;